import { handleUnauthorizedResponse } from "../../utils/authSession";
import { authenticatedApiCall } from "../../utils/api";
import { API_CONFIG } from "../../config/appConfig";
const root = "/api/admin/food-reviews";
export const listReviews = (token, cursor) => authenticatedApiCall(`${root}${cursor ? `?cursor=${encodeURIComponent(cursor)}` : ""}`, {}, token);
export const searchCatalog = (token, q) => authenticatedApiCall(`${root}/catalog?q=${encodeURIComponent(q)}`, {}, token);
export const decideReview = (token, id, index, body) => authenticatedApiCall(`${root}/${id}/items/${index}/decision`, { method: "POST", body }, token);
export const deletePhoto = (token, id) => authenticatedApiCall(`${root}/${id}/photo`, { method: "DELETE" }, token);
export const syncFood = (token, id, foodId) => authenticatedApiCall(`${root}/${id}/sync`, { method: "POST", body: { foodId } }, token);
export async function loadPhoto(token, id, signal) {
  const response = await fetch(`${API_CONFIG.BASE_URL}${root}/${id}/photo`, { headers: { Authorization: `Bearer ${token}` }, signal, cache: "no-store" });
  handleUnauthorizedResponse(response, token);
  if (!response.ok) throw new Error("사진을 불러오지 못했습니다.");
  return URL.createObjectURL(await response.blob());
}
export const nutrients = [
  ["calorie", "칼로리", "kcal", 1000], ["protein", "단백질", "g", 100],
  ["calcium", "칼슘", "mg", 10000], ["magnesium", "마그네슘", "mg", 10000],
  ["phosphorus", "인", "mg", 10000], ["vitaminD", "비타민 D", "μg", 1000],
];
export const categories = ["빵 및 과자류", "음료 및 차류", "국 및 탕류", "볶음류", "생채·무침류", "유제품류 및 빙과류", "밥류", "튀김류", "찌개 및 전골류", "면 및 만두류", "구이류", "나물·숙채류", "조림류", "전·적 및 부침류", "찜류", "죽 및 스프류", "김치류", "장류, 양념류", "장아찌·절임류", "젓갈류", "수·조·어·육류", "기타"];
